import { Injectable } from "@angular/core";
import { Address } from "../../models/address";
import { DataProvider } from "../data/data";
import { URLSearchParams } from '@angular/http';
import { LoginProvider } from "../login/login";
import { Guid } from '../../utils/guid';

// not available
const ROUTE = 'address';

@Injectable()
export class AddressProvider extends DataProvider<Array<Address>>{
    addresses: Array<Address>;
    
    constructor(private loginProvider: LoginProvider){
        super("ADDRESS");
        this.addresses = new Array<Address>();
    }

    /**
     * Retrieves addresses of current user from the database.
     */
    public getAddresses(): Array<Address> {
        return this.addresses;
    }

    /**
     * Updates given address in the database.
     * @param address Address to be updated
     */
    public async updateAddress(address: Address, contactDetailsId?: string): Promise<boolean> {
        if(!contactDetailsId) {
            return;
        }
        var form = new URLSearchParams();
        form.append('zip_code', address.zip_code);
        form.append('city', address.city);
        form.append('country', address.country);
        form.append('number', address.number);
        form.append('street', address.street);
        form.append('address_type_uuid', address.type.uuid);
        form.append('address_uuid', address.uuid);
        return this.auth.put('contactdetails' + `/${contactDetailsId}`, form).then(x => x != null);
    }

    /**
     * Creates new address in database.
     * @param address Address to be created
     */
    public async createAddress(address: Address, contactDetailsId?: string): Promise<boolean> {
        if(!contactDetailsId) {
            address.uuid = Guid.create();
            this.addresses.push(address);
            return;
        }
        var form = new FormData();
        form.append('zip_code', address.zip_code);
        form.append('city', address.city);
        form.append('country', address.country);
        form.append('number', address.number);
        form.append('street', address.street);
        form.append('address_type_uuid', address.type.uuid);
        return this.auth.post(`contactdetails/${contactDetailsId}`, form).then(x => x != null);
    }

    /**
     * Deletes address with specified id from database.
     * @param id Address id to be deleted
     */
    public async deleteAddress(uuid: string, contactDetailsId: string): Promise<boolean>{
        return this.auth.delete(`contactdetails/${contactDetailsId}/${ROUTE}/${uuid}`).then(x => x!=null);
    }
}


// WEBPACK FOOTER //
// ./src/providers/address/address.ts